import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '../constants/regex.constants';
import { getShopUrlSegments, normalizeShopUrl } from '../helpers/shop-url.helper';
import { RESERVED_URLS } from '../constants/reserved-urls.constants';

export function urlSlugCustomFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const rawValue = typeof control.value === 'string' ? control.value : '';

    if (!rawValue) {
      return { urlRequired: true };
    }

    if (!rawValue.startsWith('/')) {
      return { urlInvalidFormat: true };
    }

    if (RESERVED_URLS.some((reserved) => rawValue.toLowerCase().startsWith(reserved))) {
      return { urlReserved: true };
    }

    const value = normalizeShopUrl(rawValue);

    if (!value) {
      return { urlInvalidFormat: true };
    }

    if (value.length > 255) {
      return {
        urlTooLong: {
          requiredLength: 255,
          actualLength: value.length,
        },
      };
    }

    if (!REGEX.url.test(value)) {
      return { urlInvalidFormat: true };
    }

    const segments = getShopUrlSegments(value);

    if (segments.length < 2) {
      return { missingSlug: true };
    }

    if (segments.some((segment) => segment.length < 3)) {
      return { urlSlugTooShort: true };
    }

    return null;
  };
}

export function urlValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = typeof control.value === 'string' ? control.value.trim() : '';

    if (!value) {
      return null;
    }

    const urlPattern = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(:[0-9]+)?(\/.*)?$/;
    
    const isValid = urlPattern.test(value);

    return isValid ? null : { invalidWebUrl: true };
  };
}

export function makeUrlOptional(validator: ValidatorFn): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || (typeof value === 'string' && !value.trim())) {
      return null;
    }
    return validator(control); 
  };
}